export const PROCTORING_CONFIGURATION_FIELDS = [
  "audioCapture",
  "compareSource",
  "screenCapture",
  "detectMultipleFaces",
  "detectFace",
  "detectDevice",
];

export const RESULT_CHECK_TO_PROCTORING_FEATURE_MAPPING = {
  noFacesDetectedCheck: "detectFace",
  unmatchedFacesCheck: "compareSource",
  multipleFacesDetectedCheck: "detectMultipleFaces",
  devicesDetectedCheck: "detectDevice",
};

export const PROCTORING_CONFIGURATION_DEFAULT_SETTINGS = {
  enabled: {
    // 1 = enabled with AI features
    // 2 = enabled without AI features
    1: {
      audioCapture: true,
      compareSource: true,
      screenCapture: true,
      detectMultipleFaces: true,
      detectFace: true,
      detectDevice: true,
    },
    2: {
      audioCapture: true,
      compareSource: false,
      screenCapture: true,
      detectMultipleFaces: false,
      detectFace: false,
      detectDevice: false,
    },
  },
  disabled: {
    audioCapture: false,
    compareSource: false,
    screenCapture: false,
    detectMultipleFaces: false,
    detectFace: false,
    detectDevice: false,
  },
};

export const PROCTORING_HELP_DOC_URL = {
  na: "https://criteria.helpdocs.io/article/cbcut6asft-proctoring",
  apac: "https://criteria.helpdocs.io/article/cbcut6asft-proctoring",
};

// Returns the proctoring configuration based on the platform proctoring enabled value
// toggleCheckStatus = false returns disabled configuration
// platformProctoringEnabled = 1 returns enabled with AI features
// platformProctoringEnabled = 2 returns enabled without AI features
export const getProctoringDefaultConfiguration = (
  platformProctoringEnabled,
  toggleCheckStatus = false
) => {
  if (!toggleCheckStatus) {
    return PROCTORING_CONFIGURATION_DEFAULT_SETTINGS.disabled;
  }

  switch (platformProctoringEnabled) {
    case 1:
    case 2:
      return PROCTORING_CONFIGURATION_DEFAULT_SETTINGS.enabled[
        platformProctoringEnabled
      ];
    case 0:
    default:
      return PROCTORING_CONFIGURATION_DEFAULT_SETTINGS.disabled;
  }
};
